export const DEFAULT_ATTRIBUTE_COL_WIDTH = 152
export const DEFAULT_ITEM_COL_WIDTH = 130
export const COLUMN_PADDING = 6
export const ROW_PADDING = 6
export const DEFAULT_IMAGE_RATIO = 1.5
export const DEFAULT_FULLSCREEN_IMAGE_RATIO = 0.7

export const DEFAULT_ITEM_NAME = 'item'

export const DEFAULT_SPLIT_BY = 'none'

export const DEFAULT_ANALYSIS_MODE = 'main'
export const DEFAULT_MAIN_ANALYSIS_NAME = 'Indexing'
export const DEFAULT_SIGTEST_ANALYSIS_NAME = 'Pairwise SigTest'

export const DEFAULT_COLOR_THEME = [
  '#8CC63F',
  '#60AC66',
  '#419982',
  '#1D83A2',
  '#1868A6',
  '#135182',
  '#003863',
  '#a9d46f',
  '#9bd49f',
  '#71b3a1',
  '#56a2b9',
  '#528ebc',
  '#4e7da1',
  '#406a8a',
  '#c6e39f',
  '#bce2bf',
  '#a0ccc1',
  '#8ec1d1',
  '#8cb4d3',
  '#89a8c1',
  '#809cb1'
]
